import { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type SpinnerProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'small' | 'medium' | 'large'
}

const Spinner = ({ className, variant = 'medium', ...props }: SpinnerProps) => {
  return (
    <span
      className={cn(
        'block animate-rotate',
        {
          'h-[1.6rem] w-[1.6rem]': variant === 'small',
          'h-[3.0rem] w-[3.0rem]': variant === 'medium',
          'h-[23.0rem] w-[23.0rem]': variant === 'large'
        },
        className
      )}
      {...props}
    >
      <svg viewBox="25 25 50 50" className="animate-spin">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth={variant === 'small' ? 4 : variant === 'medium' ? 3 : 0.2}
          strokeMiterlimit="10"
          className="stroke-current"
        />
      </svg>
    </span>
  )
}

export default Spinner
